import {
  LuActivity, LuBadgeCheck, LuCpu, LuDownload, LuEye, LuFileDown, LuFileEdit, LuKeyRound, LuLock,
  LuLogIn, LuLogOut, LuPlus, LuPrinter, LuSend, LuSettings, LuShieldAlert, LuShieldCheck, LuShieldOff,
  LuTimerReset, LuTrash2, LuUnlock, LuUpload, LuUsers, LuVenetianMask, LuXCircle,
} from 'react-icons/lu';

// Icon for an audit event: the exact event first, then the verb at the front
// of the action ("export.project"), then a word inside it ("submit_bank"),
// then the category. Icons say what happened; colour is left to the outcome.

const EXACT = {
  'auth.login': LuLogIn,
  'auth.logout': LuLogOut,
  'auth.login_failed': LuShieldAlert,
  'auth.password_reset': LuKeyRound,
  'impersonation.start': LuVenetianMask,
  'impersonation.stop': LuVenetianMask,
  'security.session_revoked': LuShieldOff,
  'security.token_reuse': LuShieldAlert,
  'security.rate_limit_cleared': LuUnlock,
  'project.access_changed': LuLock,
};

const PREFIX = {
  export: LuDownload,
  print: LuPrinter,
  download: LuFileDown,
  view: LuEye,
};

// Order matters: "request_revise" is a request before it is a revise.
const KEYWORDS = [
  [/approve|accept|(^|[._])signed?($|[._])|release/, LuBadgeCheck],
  [/reject|cancel|fail/, LuXCircle],
  [/withdraw|rollback|revert|reopen|unreview/, LuTimerReset],
  [/submit|send|request|mailer|confirm|remind/, LuSend],
  [/upload|attach|import/, LuUpload],
  [/remove|destroy|delete|purge/, LuTrash2],
  [/create|add|clone|copy|insert/, LuPlus],
  [/update|edit|change|assign|set_|sync/, LuFileEdit],
];

const BY_CATEGORY = {
  auth: LuLogIn,
  security: LuShieldCheck,
  permission: LuUsers,
  setting: LuSettings,
  export: LuDownload,
  system: LuCpu,
  data: LuActivity,
};

export const eventIcon = (action, category) => {
  const name = String(action || '');
  if (EXACT[name]) return EXACT[name];
  if (name.startsWith('impersonation.')) return LuVenetianMask;

  const head = name.split('.')[0];
  if (name.includes('.') && PREFIX[head]) return PREFIX[head];

  const lower = name.toLowerCase();
  const match = KEYWORDS.find(([pattern]) => pattern.test(lower));
  if (match) return match[1];

  return BY_CATEGORY[category] || LuActivity;
};

// Neutral tile; red only for a failed or refused event.
export const iconTileClass = (outcome) => (
  outcome === 'failure'
    ? 'tw-bg-red-50 tw-text-red-600 tw-ring-1 tw-ring-inset tw-ring-red-100'
    : 'tw-bg-slate-100 tw-text-slate-600 tw-ring-1 tw-ring-inset tw-ring-slate-200'
);
